import { render, staticRenderFns } from "./package.vue?vue&type=template&id=2be2c799&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be2c799",
  null
  
)

export default component.exports